import React, { useEffect, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  setActiveTab,
  setApplicationInfo,
} from "../../../redux/slice/customer/customerSlice";
import { flashMessage as flash } from "../../../utils/flash";
import useFileUpload from "../../../utils/hooks/useFileUpload";
import useFilter from "../../../utils/hooks/useFilter";
import useInputChange from "../../../utils/hooks/useInputChange";
import Form from "../../form/Form";
import { isEmptyObject } from "./../../../utils/validators/validators";
import { useSignature } from "../../../utils/hooks/useSignature";

const BasicInformation = ({ bizInfoRef }) => {
  const { user } = useSelector((state) => state.auth?.user);
  const { offices } = useSelector((state) => state.office);
  const { allStates } = useSelector((state) => state.staff);
  const { application_info } = useSelector((state) => state.customer);
  const [isUploading, setIsUploading] = useState(false);

  const {
    value: sign,
    Signature,
    clearSignature,
    saveSignature,
  } = useSignature();

  const [userInput, setUserInput] = useState({
    title: "",
    first_name: "",
    last_name: "",
    middle_name: "",
    state_of_origin: "",
    gender: "",
    marital_status: "",
    branch_id: user?.office_id,
    dob: "",
    passport: "",
    customer_signature: "",
  });
  const [selectedFile, setSelectedFile] = useState("");

  const [error, setError] = useState({});
  let { removeErrorBySlug } = useFilter(error);
  const [input, handleChange] = useInputChange(
    application_info,
    setUserInput,
    error,
    setError
  );
  const { fileUrl, singleFileUpload } = useFileUpload();

  const dispatch = useDispatch();
  const location = useLocation();

  const fileTypes = ["JPG", "PNG", "JPEG", "PDF", "DOC", "DOCX"];

  const handleFileChange = (file) => {
    setIsUploading(true);
    setSelectedFile(file);
    singleFileUpload(file);
  };

  const handleSubmit = () => {
    if (isEmptyObject(error)) {
      // if (!selectedFile) {
      //   flash("error", "please upload passport");
      //   return;
      // } else {
      //   if (!sign) {
      //     flash("error", "Customer signature required");
      //     return;
      //   }
      // }
      console.log(userInput.branch_id, "userInput");

      setUserInput({ ...userInput, customer_signature: sign });
      bizInfoRef.current.click();
    }
  };

  useEffect(() => {
    dispatch(setApplicationInfo(userInput));
    if (userInput.identity_type == "national_id") {
      setError(removeErrorBySlug("date_of_expiration"));
    }
  }, [userInput]);

  useEffect(() => {
    if (fileUrl) {
      setIsUploading(false);
      setUserInput({ ...userInput, passport: fileUrl });
    }
  }, [fileUrl]);

  return (
    <div className="border border-top-0 px-3">
      <Form setError={setError} submitHandler={handleSubmit} values={userInput}>
        <div className="row mb-2">
          <div className="mb-0 mt-3 col-md-3">
            <label
              htmlFor="inputEmail4"
              className="form-label d-flex align-baseline"
            >
              <span>Title</span>
              <span className="text-danger">*</span>
            </label>
            <select
              textname="title"
              name="title"
              onChange={handleChange}
              value={input.title}
              id="title"
              className={`form-select ${error.title && "is-invalid"}`}
            >
              <option value="">-- select an option--</option>
              <option value="Mr">Mr</option>
              <option value="Mrs">Mrs</option>
              <option value="master">Master</option>
            </select>
            {error.title && (
              <span className="invalid-feedback">{error.title}</span>
            )}
          </div>
          <div className="mb-0 mt-3 col-md-3">
            <label
              htmlFor="inputEmail4"
              className="form-label d-flex align-baseline"
            >
              <span>First Name</span>
              <span className="text-danger">*</span>
            </label>
            <input
              textname="first name"
              name="first_name"
              onChange={handleChange}
              value={input.first_name}
              id="first_name"
              type="text"
              className={`form-control ${error.first_name && "is-invalid"}`}
              placeholder="First Name"
            />
            {error.first_name && (
              <span className="invalid-feedback">{error.first_name}</span>
            )}
          </div>
          <div className="mb-0 mt-3 col-md-3">
            <label
              htmlFor="inputEmail4"
              className="form-label d-flex align-baseline"
            >
              <span>Middle Name</span>
            </label>
            <input
              textname="middle name"
              validate="false"
              name="middle_name"
              onChange={handleChange}
              value={input.middle_name}
              id="middle_name"
              type="text"
              className={`form-control ${error.middle_name && "is-invalid"}`}
              placeholder="First Name"
            />
          </div>
          <div className="mb-0 mt-3 col-md-3">
            <label
              htmlFor="inputEmail4"
              className="form-label d-flex align-baseline"
            >
              <span>Last Name</span>
              <span className="text-danger">*</span>
            </label>
            <input
              textname="last name"
              name="last_name"
              onChange={handleChange}
              value={input.last_name}
              id="last_name"
              type="text"
              className={`form-control ${error.last_name && "is-invalid"}`}
              placeholder="Last Name"
            />
            {error.last_name && (
              <span className="invalid-feedback">{error.last_name}</span>
            )}
          </div>
        </div>

        <div className="row mb-2">
          <div className="mb-0 mt-3 col-md-4">
            <label
              htmlFor="inputEmail4"
              className="form-label d-flex align-baseline"
            >
              <span>Gender</span>
              <span className="text-danger">*</span>
            </label>
            <select
              textname="gender"
              name="gender"
              onChange={handleChange}
              value={input.gender}
              id="gender"
              className={`form-select ${error.gender && "is-invalid"}`}
            >
              <option value="">-- Select gender --</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
            </select>
            {error.gender && (
              <span className="invalid-feedback">{error.gender}</span>
            )}
          </div>
          <div className="mb-0 mt-3 col-md-4">
            <label
              htmlFor="inputEmail4"
              className="form-label d-flex align-baseline"
            >
              <span>Marital Status</span>
              <span className="text-danger">*</span>
            </label>
            <select
              textname="marital status"
              name="marital_status"
              onChange={handleChange}
              value={input.marital_status}
              id="marital_status"
              className={`form-select ${error.marital_status && "is-invalid"}`}
            >
              <option value="">-- Select Status --</option>
              <option value="single">Single</option>
              <option value="married">Married</option>
              <option value="divorced">Divorced</option>
            </select>
            {error.marital_status && (
              <span className="invalid-feedback">{error.marital_status}</span>
            )}
          </div>

          <div className="mb-0 mt-3 col-md-4">
            <label htmlFor="inputEmail4" className="form-label">
              Date of Birth
              <span className="text-danger">*</span>
            </label>
            <input
              textname="date of birth"
              name="dob"
              onChange={handleChange}
              value={input.dob}
              type="date"
              id="dob"
              className={`form-control ${error.dob && "is-invalid"}`}
            />
            {error.dob && <span className="invalid-feedback">{error.dob}</span>}
          </div>
        </div>

        <div className="row mb-2">
          <div className="mb-0 mt-3 col-md-4">
            <label
              htmlFor="inputEmail4"
              className="form-label d-flex align-baseline"
            >
              <span>State Of Origin</span>
              <span className="text-danger">*</span>
            </label>
            <select
              textname="state of origin"
              name="state_of_origin"
              onChange={handleChange}
              value={input.state_of_origin}
              type="date"
              id="state_of_origin"
              className={`form-select ${error.state_of_origin && "is-invalid"}`}
            >
              <option value="">-- Select Option --</option>
              {allStates?.map(({ name, id }) => (
                <option key={id} value={name}>
                  {name}
                </option>
              ))}
            </select>
            {error.state_of_origin && (
              <span className="invalid-feedback">{error.state_of_origin}</span>
            )}
          </div>
          {/* <div className="mb-0 mt-3 col-md-4">
            <label
              htmlFor="inputEmail4"
              className="form-label d-flex align-baseline"
            >
              <span>Branch</span>
              <span className="text-danger">*</span>
            </label>
            <select
              textname="branch office"
              name="branch_id"
              onChange={handleChange}
              value={input.branch_id}
              type="date"
              id="branch_id"
              className={`form-select ${error.branch_id && "is-invalid"}`}
            >
              <option value="">-- Select Branch --</option>
              {offices?.offices?.map(({ office_name, id }) => (
                <option key={id} value={id}>
                  {office_name}
                </option>
              ))}
              
            </select>
            {error.branch_id && (
              <span className="invalid-feedback">{error.branch_id}</span>
            )}
          </div> */}
          <div className="col-md-4 mt-3">
            <label htmlFor="inputEmail4" className="form-label d-block">
              Upload Passport
              {/* <span className='text-danger'>*</span> */}
              {isUploading && (
                <span className="bg-dar ms-1 text-danger">
                  {" "}
                  <i
                    className={`mdi mdi-dots-circle mdi-spin fs-5 h3 mt-0`}
                  ></i>{" "}
                </span>
              )}
              {!isUploading && application_info?.document_url && (
                <span className="bg-dar ms-1 text-success">
                  {" "}
                  <i className={`mdi mdi-check fs-5 h3 mt-0`}></i>{" "}
                </span>
              )}
            </label>
            <FileUploader
              label=" Browse Passport"
              children={
                <div
                  className="borde border-dotted p-1 px-2 text-center cursor-p mt-0"
                  style={{ border: "2px dashed grey" }}
                  // onClick={handleFileChange}
                  // onDrop={handleFileChange}
                >
                  <i className="uil uil-cloud-upload fs-4"></i> Upload Passport
                  <span className="text-primary-dark mt-0"></span>
                </div>
              }
              handleChange={handleFileChange}
              onDrop={handleFileChange}
              name="file"
              types={fileTypes}
            />
            {selectedFile && (
              <img
                width={100}
                className="mt-0 ms-2"
                src={URL.createObjectURL(selectedFile)}
                alt=""
              />
            )}
          </div>
        </div>

        <div className="row mb-2">
          <div className="col-md-6 mt-2">
            <label htmlFor="inputEmail4" className="form-label d-block">
              Customer signature
              {/* <span className='text-danger'>*</span> */}
              {sign && (
                <span className="bg-dar ms-1 text-success">
                  {" "}
                  <i className={`mdi mdi-check fs-5 h3 mt-0`}></i>{" "}
                </span>
              )}
            </label>
            <div className="d-flex gap-3">
              {Signature}
              {/* {sign && (
                <div
                  style={{
                    // backgroundColor: "#f1f1ee",
                    width: "100px",
                    height: "80px",
                  }}
                >
                  <img src={sign} alt='signature' width={100} height={80} />
                </div>
              )} */}
            </div>
            <div className="d-flex gap-2 mt-2">
              <button
                type="button"
                className="btn btn-sm btn-secondary"
                onClick={() => clearSignature()}
              >
                Clear signature
              </button>
              <button
                type="button"
                className="btn btn-sm btn-info"
                onClick={() => saveSignature()}
              >
                Sign
              </button>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-end mb-3">
          <button
            type="submit"
            disabled={isUploading ? true : false}
            className="btn btn-primary"
          >
            Proceed
          </button>
        </div>
      </Form>
    </div>
  );
};

export default BasicInformation;
